import { forwardRef, HTMLAttributes, ReactChild, useEffect, useRef } from 'react';
import { VariableSizeList } from 'react-window';
import AutocompleteRenderRow from './AutocompleteRenderRow';

const useResetCache = (data: number) => {
  const ref = useRef<VariableSizeList>(null);

  useEffect(() => {
    if (ref.current !== null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);

  return ref;
};

const AutocompleteListBoxComponent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLElement>>((props, ref) => {
  const { children, ...otherProps } = props;
  const itemData: ReactChild[] = (children as ReactChild[]).flatMap(
    (item: ReactChild & { children?: ReactChild[] }) => {
      return [item, ...(item.children || [])];
    }
  );

  const itemCount = itemData.length;
  const itemSize = 32;

  const getChildSize = (child: ReactChild) => {
    if (Object.prototype.hasOwnProperty.call(child, 'group')) {
      return 32;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }

    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref} {...otherProps}>
      <VariableSizeList
        itemData={itemData}
        height={getHeight()}
        width="100%"
        ref={gridRef}
        innerElementType="ul"
        itemSize={(index) => getChildSize(itemData[index])}
        overscanCount={5}
        itemCount={itemCount}
      >
        {AutocompleteRenderRow}
      </VariableSizeList>
    </div>
  );
});

AutocompleteListBoxComponent.displayName = 'AutocompleteListBoxComponent (Autocomplete)';

export default AutocompleteListBoxComponent;
